// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3ZOYq","notes":"Notes_notes__20M6D"};